import {
  GETConversionSnapshotsResponse,
  GETLocationQueryParams,
  GETLocationResponse,
  GETShopExternalGMSDataResponse,
  GETShopsResponse,
  GETShopsResponseWithPagination,
  HttpMethod,
  IListShopByCompanyUUID,
  IResponse,
  ISupportShop,
  ISupportShopResponse,
  POSTCopyAccountsVehiclesRequest,
  POSTCopyAccountsVehiclesResponse,
  POSTSeedDataBody,
  POSTSeedDataResponse,
  POSTShopBody,
  PUTRunConversionResponse,
  PUTRunConversionShop,
  getLocationRequest
} from '@cbgms/api'
import { IPaginatedRequest } from '@cbgms/api/request'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import {
  createShop as createShopRequest,
  getShopLocalizationSettings as getShopLocalizationSettingsRequest,
  getShop as getShopRequest,
  getTakeoverUrl as getTakeoverUrlRequest,
  getTelesalesUrl as getTelesalesUrlRequest,
  listShopAll as listShopAllRequest,
  listShopByCompanyUUID as listShopByCompanyUUIDRequest,
  listShop as listShopRequest,
  seedAccountancyDataForShopRequest,
  seedDataForShop as seedDataForShopRequest,
  supportAddShopToCRM,
  supportUpdateShopsMijnGrossierRedirectRequest,
  updateShopLocalizationSettings as updateShopLocalizationSettingsRequest,
  updateShop as updateShopRequest
} from '@cbgms/api/modules/shops/requests'

import * as tenderRequests from '@cbgms/api/modules/tender-engine/requests'

import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { GETLocalisationSettingsResponse, PUTLocalisationSettingsBody } from '@cbgms/api/modules/settings'

export const listShops = (params: IPaginatedRequest) =>
  AsyncAction<GETShopsResponse>({
    type: [types.GET_SHOPS, types.GET_SHOPS_SUCCESS, types.GET_SHOPS_FAILED],
    payload: {
      api: 'support',
      request: listShopRequest(params)
    }
  })
export const listShopsAll = (params: IPaginatedRequest) =>
  AsyncAction<GETShopsResponseWithPagination>({
    type: [types.GET_SHOPS, types.GET_SHOPS_SUCCESS, types.GET_SHOPS_FAILED],
    payload: {
      api: 'support',
      request: listShopAllRequest(params)
    }
  })

export const listShopByCompanyUUID = (companyUUID: string) =>
  AsyncAction<IResponse<IListShopByCompanyUUID[]>>({
    type: [types.GET_SHOPS_BY_COMPANY_UUID, types.GET_SHOPS_BY_COMPANY_UUID_SUCCESS, types.GET_SHOPS_BY_COMPANY_UUID_FAILED],
    payload: {
      api: 'support',
      request: listShopByCompanyUUIDRequest(companyUUID)
    }
  })

export const getShop = (shopID: string) =>
  AsyncAction<ISupportShopResponse>({
    type: [types.GET_SHOP, types.GET_SHOP_SUCCESS, types.GET_SHOP_FAILED],
    payload: {
      api: 'support',
      request: getShopRequest(shopID)
    }
  })

export const createShop = (data: POSTShopBody) => ({
  type: [types.CREATE_SHOP, types.CREATE_SHOP_SUCCESS, types.CREATE_SHOP_FAILED],
  payload: {
    api: 'support',
    request: createShopRequest(data)
  }
})

export const seedDataForShop = (data: POSTSeedDataBody) =>
  AsyncAction<POSTSeedDataResponse>({
    type: [types.SEED_DATA_FOR_SHOP, types.SEED_DATA_FOR_SHOP_SUCCESS, types.SEED_DATA_FOR_SHOP_FAILED],
    payload: {
      api: 'support',
      request: seedDataForShopRequest(data)
    }
  })

export const getExternalGMSDataForShop = (shopID: string) =>
  createAsyncApiAction<GETShopExternalGMSDataResponse>('support', {
    method: HttpMethod.GET,
    url: `/modules/external-gms-link/${shopID}`
  })

export const seedAccountancyDataForShop = (data: POSTSeedDataBody) =>
  AsyncAction<POSTSeedDataResponse>({
    type: [types.SEED_DATA_FOR_SHOP, types.SEED_DATA_FOR_SHOP_SUCCESS, types.SEED_DATA_FOR_SHOP_FAILED],
    payload: {
      api: 'support',
      request: seedAccountancyDataForShopRequest(data)
    }
  })

export const runConversionForShop = (body: PUTRunConversionShop) =>
  createAsyncApiAction<PUTRunConversionResponse>('support', {
    method: 'PUT',
    url: '/modules/shop-conversions/convert',
    data: body
  })

export const loadConversionSnapshots = () =>
  createAsyncApiAction<GETConversionSnapshotsResponse>('support', {
    method: 'GET',
    url: '/modules/shop-conversions/list-conversion-snapshots'
  })

export const updateShop = (shopID: string, data: Partial<ISupportShop>) => ({
  type: [types.UPDATE_SHOP, types.UPDATE_SHOP_SUCCESS, types.UPDATE_SHOP_FAILED],
  payload: {
    api: 'support',
    request: updateShopRequest(shopID, data)
  }
})

export const resetShop = () => ({
  type: types.RESET_SHOP_STATE
})

export const postShopToCRM = (shopID: string) =>
  AsyncAction<{}>({
    type: [types.ADD_SHOP_TO_CRM, types.ADD_SHOP_TO_CRM_SUCCESS, types.ADD_SHOP_TO_CRM_FAILED],
    payload: {
      api: 'support',
      request: supportAddShopToCRM(shopID)
    }
  })

export const getTenderEngineShopInfo = (shopReferenceUUID: string, conceptUUID: string) => ({
  type: [types.GET_TENDER_ENGINE_SHOP_INFO, types.GET_TENDER_ENGINE_SHOP_INFO_SUCCESS, types.GET_TENDER_ENGINE_SHOP_INFO_FAILED],
  payload: {
    api: 'support',
    request: tenderRequests.getTenderEngineShopInfo(shopReferenceUUID, conceptUUID)
  }
})

export const getTakeoverURL = (shopID: string) => ({
  type: [types.GET_TAKEOVER_URL, types.GET_TAKEOVER_URL_SUCCESS, types.GET_TAKEOVER_URL_FAILED],
  payload: {
    api: 'support',
    request: getTakeoverUrlRequest(shopID)
  }
})

export const getTelesalesURL = (shopID: string) => ({
  type: [types.GET_TAKEOVER_URL, types.GET_TAKEOVER_URL_SUCCESS, types.GET_TAKEOVER_URL_FAILED],
  payload: {
    api: 'support',
    request: getTelesalesUrlRequest(shopID)
  }
})

export const getLocation = (params: GETLocationQueryParams) =>
  AsyncAction<GETLocationResponse>({
    type: [types.GET_LOCATION, types.GET_LOCATION_SUCCESS, types.GET_LOCATION_FAILED],
    payload: {
      api: 'support',
      request: getLocationRequest(params)
    }
  })

export const getShopLocalizationSettings = (shopID: string) =>
  AsyncAction<GETLocalisationSettingsResponse>({
    type: [types.GET_SHOP_LOCALISATION_SETTINGS, types.GET_SHOP_LOCALISATION_SETTINGS_SUCCESS, types.GET_SHOP_LOCALISATION_SETTINGS_FAILED],
    payload: {
      api: 'support',
      request: getShopLocalizationSettingsRequest(shopID)
    }
  })

export const updateShopLocalizationSettings = (shopID: string, data: PUTLocalisationSettingsBody) =>
  AsyncAction<GETLocalisationSettingsResponse>({
    type: [
      types.UPDATE_SHOP_LOCALISATION_SETTINGS,
      types.UPDATE_SHOP_LOCALISATION_SETTINGS_SUCCESS,
      types.UPDATE_SHOP_LOCALISATION_SETTINGS_FAILED
    ],
    payload: {
      api: 'support',
      request: updateShopLocalizationSettingsRequest(shopID, data)
    }
  })

export const updateShopsMijnGrossierRedirect = (shopIDs: string[]) =>
  createAsyncApiAction<GETShopsResponse>('support', supportUpdateShopsMijnGrossierRedirectRequest(shopIDs))

export const copyShopAccountsAndVehicles = (body: POSTCopyAccountsVehiclesRequest) =>
  createAsyncApiAction<POSTCopyAccountsVehiclesResponse>('support', {
    method: 'POST',
    url: '/modules/tools/copy-accounts-vehicles',
    data: body
  })

export const getVinRequestLogExport = (params: { 'start-date': string; 'end-date': string; 'shop-id': string }) =>
  createAsyncApiAction<Blob>('support', {
    method: 'GET',
    url: '/modules/vehicles/vin-request-log-export',
    params
  })
